<template>
    <section :class="[namespace(), skinStyle]">
        <ul :class="[mdsNS('list-group'), namespace('group')]">
            <li
                v-for="item in dataModel"
                :key="item.id"
                :class="[
                    mdsNS('list-group__item'),
                    item.disable ? mdsNS('list-group__item--disabled') : '',
                    namespace('__item')
                ]"
                @click.stop="goToSubView(item)"
            >
                <div :class="[mdsNS('list-group__link'), namespace('__link')]">
                    <div
                        :class="[
                            mdsNS('list-group__item-label'),
                            namespace('__item-label')
                        ]"
                    >
                        {{ item.title }}
                    </div>
                    <div
                        :class="[
                            mdsNS('list-group__item-label'),
                            namespace('__item-label'),
                            namespace('__current-selection')
                        ]"
                    >
                        {{ item.name }}
                    </div>
                    <span :class="namespace('__icon-wrapper')">
                        <svg :class="mdsNS('icon')" aria-labelledby="title">
                            <title>{{ item.name }}</title>
                            <use xlink:href="#caret-right--s"></use>
                        </svg>
                    </span>
                </div>
            </li>
        </ul>
    </section>
</template>

<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-settings-navigation',
    mixins: [mixins],
    props: {
        dataModel: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    created() {
        this.namespace = utils.namespace('ui-settings-navigation', false);
    },
    methods: {
        goToSubView(item) {
            if (item.disable) {
                return;
            }
            this.$emit('change', item);
        }
    }
};
</script>

<style lang="scss">
$namespace: 'markets-ui-settings-navigation';
@import '../../mds/constants';
.#{$namespace} {
    &-group {
        margin-bottom: 0px;
    }
    &__link {
        padding-bottom: $mds-space-inset-half-x;
        &:hover {
            cursor: pointer;
        }
    }
    &__item-label {
        padding-top: $mds-space-inset-1-x;
        font-size: $mds-font-size-s;
    }
    &__item:hover {
        svg {
            fill: #0077cf;
        }
    }
    &__current-selection {
        font-weight: $mds-font-weight-bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: calc(100% - 20px);
    }
    &__icon-wrapper {
        display: inline-block;
        position: absolute;
        right: 0;
        top: calc(50% - 8px);

        svg {
            height: $mds-size-icon-s;
            width: $mds-size-icon-s;
            fill: $mds-color-neutral-50;
        }
        svg:hover {
            fill: $mds-text-color-link-default;
        }
    }
}
</style>
